import React from "react";
import { Helmet } from "react-helmet";
import "./Resume.css";
import { motion } from "framer-motion";
import Navbar from "../../Hooks/Navbar/Navbar";
import usestyle from "../../Hooks/style/usestyle";

const Resume = () => {
  const { variant } = usestyle();

  return (
    <>
      <Helmet>
        <title>Resume - Mohammad Nour Khattab's Professional Experience</title>
        <meta
          name="description"
          content="View Mohammad Nour Khattab's professional resume, showcasing 5+ years of experience in full-stack development, technical skills, and career achievements."
        />
        <meta
          name="keywords"
          content="Full Stack Developer Resume, Web Developer CV, Professional Experience, Technical Skills, Career Achievements"
        />
        <link rel="canonical" href="https://nour-it.dev/resume" />
      </Helmet>
      <Navbar />
      {/* <motion.div
        initial={{ y: -1500 }}
        animate={{ y: 0 }}
        exit={{ x: "100vw", transition: { duration: 0.2 } }}
        transition={{ duration: 0.2, ease: "easeInOut", type: "spring", stiffness: "120" }}
        className="resume page"
      > */}
      <motion.div
        variants={variant}
        initial="initial"
        animate="animate"
        exit="exit"
        // transition="transition"
        className="resume page"
      >
        <div className="contener">
          <span className="span-line">RESUME</span>
          <div className="big-header">CHECK MY RESUME</div>
          <div className="content">
            <div className="education ">
              <p className="mid-white-header">Education</p>
              <div className="left-line items">
                <p className="mid-header-circle">BACHELOR OF INFORMATION TECHNOLOGY</p>
                <p className="date">2018 – Present</p>
                <div>
                  I am currently pursuing a Bachelor’s degree in Information Technology from the Syrian Virtual
                  University. The curriculum includes:
                  <br />
                  <br />– Advanced courses in <strong>web & mobile application development</strong>,{" "}
                  <strong>database design & management</strong>, and <strong>project planning & implementation</strong>.
                  <br />– Core subjects in <strong>programming principles</strong>, <strong>digital marketing</strong>,{" "}
                  <strong>business philosophies</strong>, <strong>performance optimization</strong>, and{" "}
                  <strong>operating systems</strong>.<br />– Practical training in{" "}
                  <strong>digital circuit design</strong>, <strong>accounting basics</strong>, and{" "}
                  <strong>quantitative mathematics</strong>.<br />– Emphasis on lifelong learning, teamwork,
                  professional ethics, and communication skills as part of the IT engineer formation.
                </div>
              </div>
              <div className="left-line items">
                <p className="mid-header-circle">Vocational Institute of Information Technology</p>
                <p className="date">2010 – 2014</p>
                <div>
                  I completed my technical education in computer science with a focus on networks, web design, and
                  desktop application development. The program covered programming languages such as Pascal, Delphi, C,
                  and C++, along with foundational courses in electronics, logic circuits, and microprocessors (8086 &
                  8080).
                  <br />
                  <br />
                  Later, I joined a vocational IT institute where I studied C++, C#, web technologies, Oracle databases,
                  network design and management, and machine-level programming.
                </div>
              </div>
            </div>
            <div className="experience">
              <p className="mid-white-header">Experience</p>

              {/* Rexa4 */}
              <div className="left-line items">
                <p className="mid-header-circle">Full Stack Developer</p>
                <p className="date">Dec 2023 – Present</p>
                <div className="description">
                  <p>
                    Currently working at{" "}
                    <a href="https://rexa4.com" target="_blank" rel="noopener noreferrer">
                      Rexa4
                    </a>{" "}
                    as a Full Stack Developer.
                  </p>
                  <p>
                    Leading project development and implementation using React.js, Next.js, Fastify, PHP (Laravel), and
                    Prisma. Responsible for managing the development team, collaborating with marketing, and optimizing
                    backend and frontend performance.
                  </p>
                </div>
              </div>

              {/* MB Digital Technology */}
              <div className="left-line items">
                <p className="mid-header-circle">Full Stack Developer</p>
                <p className="date">Jun 2023 – Dec 2023</p>
                <div className="description">
                  <p>
                    Worked at{" "}
                    <a href="https://mbdigitaltechnology.com" target="_blank" rel="noopener noreferrer">
                      MB Digital Technology
                    </a>{" "}
                    as a Full Stack Developer.
                  </p>
                  <p>
                    Built and maintained mobile applications (React Native), web apps with Next.js 13.4, and managed
                    infrastructure with AWS & Cloudflare. Also led the development team and integrated secure payment
                    methods across multiple platforms.
                  </p>
                </div>
              </div>

              {/* Al Ashram Contracting */}
              <div className="left-line items">
                <p className="mid-header-circle">IT Assistant</p>
                <p className="date">Mar 2023 – Jun 2023</p>
                <div className="description">
                  <p>
                    Worked at{" "}
                    <a href="https://al-ashram.com/" target="_blank" rel="noopener noreferrer">
                      Al Ashram Contracting
                    </a>{" "}
                    as an IT Assistant.
                  </p>
                  <p>
                    Focused on server administration, Office365 integration, ERP system implementation, security
                    policies, backups, and system troubleshooting. Participated in technical support and internal tool
                    improvement.
                  </p>
                </div>
              </div>

              {/* Focal X */}
              <div className="left-line items">
                <p className="mid-header-circle">Frontend Web Developer</p>
                <p className="date">Oct 2021 – Mar 2023</p>
                <div className="description">
                  <p>
                    Worked at{" "}
                    <a href="https://focal-x.com" target="_blank" rel="noopener noreferrer">
                      Focal X Agency
                    </a>{" "}
                    as a Frontend Developer.
                  </p>
                  <p>
                    Built{" "}
                    <a href="https://focal-x.com" target="_blank" rel="noopener noreferrer">
                      Focal X’s website
                    </a>{" "}
                    using vanilla JS and CSS, developed a dashboard with React and Redux in a Scrum environment, and
                    contributed to projects like{" "}
                    <a href="https://alwansystem.com/" target="_blank" rel="noopener noreferrer">
                      Alwan System
                    </a>
                    . Supervised interns and ensured reusable, testable component development.
                  </p>
                </div>
              </div>

              {/* Mirum Agency */}
              <div className="left-line items">
                <p className="mid-header-circle">Frontend Web Developer</p>
                <p className="date">Sep 2020 – Oct 2021</p>
                <div className="description">
                  <p>
                    Worked remotely at Mirum Agency. Focused on building responsive websites using HTML, CSS,
                    JavaScript, jQuery, Bootstrap, and React. Collaborated with remote teams and improved cross-browser
                    compatibility and UI performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Resume;
